<cpq-script-history-datatable #datatable
  [scriptHistoryService]="scriptHistoryService"
  [scriptId]="scriptId"
  [scriptConfig]="scriptConfig"
  (showRecordDetails)="showRecordDetail($event)" (showComparedRecords)="showComparedRecords($event)"
  [languageType]="languageType">
</cpq-script-history-datatable>

<div class="margin-top-20">
  @if (isScriptDetailsAvailable) {
    <cpq-script-details [scriptId]="scriptId" [scriptHistoryRecordId]="scriptHistoryRecordId" [scriptHistoryRecordVersionNumber]="scriptHistoryRecordVersionNumber" [scriptHistoryService]="scriptHistoryService" [languageType]="languageType"></cpq-script-details>
  }
</div>
<div class="margin-top-20">
  @if (isCompareViewAvailable) {
    <cpq-text-compare [originalObject]="originalObject" [compareObject]="compareObject"></cpq-text-compare>
  }
</div>
